import React, { createContext, useContext } from 'react';
import { AppState, AppAction } from '../types';

interface AppStateContextValue {
  state: AppState;
  dispatch: React.Dispatch<AppAction>;
}

export const AppStateContext = createContext<AppStateContextValue | null>(null);

export function useAppState(): AppStateContextValue {
  const ctx = useContext(AppStateContext);
  if (!ctx) throw new Error('useAppState must be used inside AppStateContext.Provider');
  return ctx;
}
